import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'petitionGuidesAll',
		path: '/petition-guides/category/all',
		// priority must beat the future /petition-guides/category/:categorySlug (individual category pages,
		// not yet built) — routes sort by priority descending only, and Express registers
		// first-match-wins, so without this the dynamic category route would swallow this URL server-side.
		priority: 10,
		component: loadable(async () => import(/* webpackChunkName: "pages/petitionGuides-category-all" */ './index'), {
			exportName: 'PetitionGuidesAll',
			fallback: Loading,
		}),
		frame: true,
		ssr: { enabled: true, seo: true },
	},
];
